import SevenBridges from '@public/images/logos/7bridges.png'
import Chainio from '@public/images/logos/chainio.png'
import Logixboard from '@public/images/logos/logixboard.png'
import Image from 'next/image'

import QuoteTile from '@/components/MovingChipAnimation/QuoteTile'

export const AccreditedTile = () => {
    return (
        <QuoteTile
            imageSrc={'/images/moving-chip-animation/card-green-lagoon.png'}
            text={'Audited and ISO certified calculation methodology'}
            logo={
                <Image
                    src={'/images/moving-chip-animation/card-two-logos-smart-freight.png'}
                    alt={'Smart Freight Center logo'}
                    height={24}
                    width={124.5}
                />
            }
        />
    )
}

export const AutomatedMatchingTile = () => {
    return (
        <QuoteTile
            imageSrc={'/images/moving-chip-animation/card-sky.png'}
            text={'Automated matching of products to emissions factors, powered by AI.'}
        />
    )
}

export const GlobalCoverageTile = () => {
    return (
        <QuoteTile
            imageSrc={'/images/moving-chip-animation/card-laptop.png'}
            text={'Global coverage of products, materials, transportation, and shipments.'}
        />
    )
}

export const LogixboardQuoteTile = () => {
    return (
        <QuoteTile
            logo={<Image src={Logixboard} alt={`Logixboard logo`} height={16} />}
            imageSrc={'/images/moving-chip-animation/card-logixboard.png'}
            text={'Helping freight forwarders delight their customers with emissions visibility'}
        />
    )
}

export const ChainioQuoteTile = () => {
    return (
        <QuoteTile
            logo={<Image src={Chainio} alt={`Chain-io logo`} height={16} />}
            imageSrc={'/images/moving-chip-animation/card-chain-io.png'}
            text={'Enables reporting on Scope 3 emissions across the entire shipment lifecycle'}
        />
    )
}

export const SevenBridgesQuoteTile = () => {
    return (
        <QuoteTile
            logo={<Image src={SevenBridges} alt={`SevenBridges logo`} height={16} />}
            imageSrc={'/images/moving-chip-animation/card-7bridges.png'}
            text={'Turning Scope 3 logistics emissions into competitive edge for customers  '}
        />
    )
}
